import { useEffect } from "react";

const Neutraceuticals = () => {
  useEffect(() => {
    document.title = "Neutraceuticals - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/nutraceuticals.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">
            Neutraceuticals
          </h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">
              {/* <h2>Nutraceuticals</h2> */}

              <h2>
                Nature’s Bioactive Boost: The Role of Oils, Extracts &amp;
                Butters in the Nutraceuticals Industry
              </h2>

              <p>
                At Deww Botanicals, we believe that true wellness begins with
                nature’s purest ingredients. Our selection of natural oils,
                liquid extracts, and plant butters are rich in bioactive
                compounds designed to enhance the nutritional value and
                functional benefits of nutraceutical products, effectively
                bridging the gap between food and medicine.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?nutraceuticals,natural-supplements"
                alt="Nutraceuticals natural ingredients"
              /> */}

              <h3>Carrier Oils: Nutrient-Dense Foundations</h3>

              <p>
                Cold-pressed carrier oils such as flaxseed, black seed
                (kalonji), sesame, coconut, and olive oil are abundant in omega
                fatty acids, antioxidants, and fat-soluble vitamins (A, D, E,
                K). These oils support:
              </p>
              <ul>
                <li>Heart health</li>
                <li>Anti-inflammatory responses</li>
                <li>
                  Improved absorption of nutrients (particularly fat-soluble
                  vitamins and curcumin)
                </li>
                <li>Skin and joint support from within</li>
              </ul>

              <p>
                Carrier oils can be utilized in softgel capsules, oral drops, or
                as edible oils, serving as both functional ingredients and
                effective delivery systems.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?flaxseed,carrier-oil"
                alt="Flaxseed and natural carrier oils"
              /> */}

              <h3>
                Essential Oils: Potent Concentrates for Functional Support
              </h3>

              <p>
                Although used in smaller doses, essential oils like peppermint,
                ginger, clove, and oregano are incorporated into nutraceuticals
                due to their antimicrobial, digestive, antioxidant, and
                immune-boosting properties.
              </p>

              <ul>
                <li>
                  Digestive blends (e.g., peppermint oil for bloating and IBS)
                </li>
                <li>Oral health capsules</li>
                <li>Natural preservatives and flavor enhancers</li>
                <li>Respiratory and immunity blends</li>
              </ul>

              <p>
                Typically, essential oils are encapsulated or added in
                controlled concentrations to ensure safe internal use.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?peppermint,essential-oil"
                alt="Peppermint and essential oils"
              /> */}

              <h3>Liquid Herbal Extracts: Fast-Absorbing Plant Medicine</h3>

              <p>
                Our liquid extracts are potent, water- or alcohol-based
                formulations that provide rapid therapeutic benefits from herbs.
              </p>

              <ul>
                <li>Fast absorption and bioavailability</li>
                <li>Ideal for tinctures, wellness shots, tonics, and syrups</li>
                <li>
                  Suitable for stress relief, immunity enhancement,
                  detoxification, energy boost, digestion, and more
                </li>
              </ul>

              <p>
                Examples include ashwagandha extract, tulsi (holy basil), amla,
                and turmeric, all of which are grounded in Ayurvedic tradition.
              </p>

              {/* <img
                src="https://source.unsplash.com/800x400/?herbal-extract,ayurveda"
                alt="Herbal extracts like tulsi and ashwagandha"
              /> */}

              <h3>Why Nutraceutical Brands Trust Deww Botanicals:</h3>

              <ul>
                <li>Clean-label, food-grade ingredients</li>
                <li>Cold-pressed, solvent-free extraction methods</li>
                <li>High bioavailability and functional performance</li>
                <li>Backed by Ayurvedic wisdom and modern science</li>
              </ul>

              <h2>Enhance Your Health Naturally</h2>

              <p>
                With Deww Botanicals, experience the fusion of nutraceutical
                innovation and nature’s most potent ingredients. Whether you’re
                formulating a supplement, creating a functional food, or
                developing a wellness tonic, our natural oils, extracts, and
                butters can help bring your vision to life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Neutraceuticals;
